import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { EmpInfo } from '../../model/emp.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../../service/token.service';
import { GlobalService } from '../../service/global.service';
import {
  environment
} from 'src/environments/environment';
import { RoleInfo } from '../../model/role.model';
import { JobInfo } from '../../model/Job.model';
import { PositionLevelInfo } from '../../model/PositionManagementInfo.model';
import { DivisionInfo } from '../../model/division.model';

@Component({
  selector: 'app-employee-select',
  templateUrl: './employee-select.component.html',
  styleUrls: ['./employee-select.component.css']
})
export class EmployeeSelectComponent implements OnInit {

  @Output() public onSelected = new EventEmitter();
  @Input() OnlyRole: string;
  @Input() ContactlistProjectCode: string;
  @Input() Multiselect: boolean = false;

  @Input() ButtonColor: string = 'btn-primary';
  @Input() ButtonOutlineColor: string = '';
  @Input() TableColor: string = 'table-stand-greenlight';

  @Input() Job: string = '';
  @Input() CompanyCode: string ;
  @Input() OnlyEmployeeType: string = '';


  selectedemp: string;

  baseurl: string;
  _ForK2: string;
  _EmpCode: string;

  // Primary data
  modelOnPromise: Promise<EmpInfo[]>
  modelList: EmpInfo[] = [];

  //search
  txtSearchEmpCode: string;
  txtSearchEmpName: string
  txtSchEmpJob: string;
  txtSchEmpRole: string;
  txtSchEmpPosition: string;
  txtSchEmpDivision: string;
  checkboxEmpInternal: boolean = true;
  checkboxEmpExternal: boolean = false;

  isSearchSubmitted: boolean = false;
  lJobTitle: JobInfo[] = [];
  lRole: RoleInfo[] = [];
  lPosition: PositionLevelInfo[] = [];
  lDivision: DivisionInfo[] = [];

  //Pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number 
  public countEmp: number
  public totalPages: number
  public environment: number
  public pagesize: number = 5;

  

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = localStorage.getItem("EmpCode");
  }

  ngOnInit(): void {
    this.reset();
    this.currentPageNumber = 1;
    this.LoadData();

    this.LoadJob().then((data) => {
      this.lJobTitle = data;
    });
    this.LoadPosition().then((data) => {
      this.lPosition = data;
    });
    this.LoadDivision().then((data) => {
      this.lDivision = data;
    });
    //this.LoadRole().then((data) => {
    //  this.lRole = data;
    //});
    this.setOnlyEmployeeType();

    
  }

  setOnlyEmployeeType(){
    if(this.OnlyEmployeeType != '' && this.OnlyEmployeeType != null){
      if(this.OnlyEmployeeType == 'Internal'){
          this.checkboxEmpInternal = true;
          this.checkboxEmpExternal = false;

      }else if(this.OnlyEmployeeType == 'External'){
          this.checkboxEmpInternal = false;
          this.checkboxEmpExternal = true;

      }
    }
  }

  setDefinedConditions() {
    if (this.Job != '') this.txtSchEmpJob = this.Job;
  }

  btnClick_searchEmp() {
    this.isSearchSubmitted = true;
    this.selectedemp = "";
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.pagesize = 5;
    this.LoadData()
  }

  btnClick_clearSearchEmp() {
    this.reset();
    this.LoadData();
    let x = this.modelList.filter(x => x.EmpCode == "XXXXXXXXXX");

    $('#checkallbox').prop('checked', false);

    this.onSelected.emit(x);
  }

  btnClick_selectEmp(empcode) {
    console.log("xxxx...", empcode);
    let x = this.modelList.filter(x => x.EmpCode == empcode);
    this.selectedemp = empcode;
    this.onSelected.emit(x);
  }

  btnClick_multiselectEmp() {
    var listselected = $('[name="checkboxEmpMultiselect"]:checked').filter(function () {
      return !(this as HTMLInputElement).disabled
    });

    let emplist = [];

    for (let x = 0; x < listselected.length; x++) {
      emplist.push((<HTMLInputElement>listselected[x]).value);
    }

    let emplistres = this.modelList.filter(emp => emplist.includes(emp.EmpCode));

    this.onSelected.emit(emplistres);
  }

  btnClick_showAll() {
    this.isSearchSubmitted = true;
    this.selectedemp = "";
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.pagesize = 99999;
    this.LoadData()
  }

  reset() {
    this.txtSearchEmpCode = ""
    this.txtSearchEmpName = "";
    this.txtSchEmpJob = "";
    this.txtSchEmpRole = "";
    this.txtSchEmpPosition = "";
    this.txtSchEmpDivision = "";
    this.selectedemp = "";
    this.checkboxEmpInternal = true;
    this.checkboxEmpExternal = false;
    this.indexNo = 0;
    this.currentPageNumber = 1;
    this.pagesize = 5;

    this.isSearchSubmitted = false;
    this.setDefinedConditions();
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");
    $('[name="checkboxEmpMultiselect"]').filter(function () {
      return !(this as HTMLInputElement).disabled
    }).prop('checked', check);

    this.btnClick_multiselectEmp();
  }

  //============================ Data Loading [Start] =========================================
  LoadData() {
    this.getEmp()
      .then(
        data => {
          this.modelList = data;
          //this.YearList = [...new Set(data.map(event => new Date(event.TimeSheetDate).getFullYear().toString()))];
          this.countEmp = (this.modelList.length != 0) ? data[0].countEmp : 0;
        }
      ).then(() => {
        if (this.countEmp == 0) {
          this.currentPageNumber = 0;
        }
        this.totalPages = Math.ceil(this.countEmp / this.pagesize)
      })
  }

  async getEmp(): Promise<EmpInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.pagesize;

      var objectjson = {};

      objectjson['EmpCode'] = this.txtSearchEmpCode;
      objectjson['EmpName_TH'] = this.txtSearchEmpName;
      objectjson['JobCode'] = this.txtSchEmpJob;
      objectjson['DivisionCode'] = this.txtSchEmpDivision;
      objectjson['PositionCode'] = this.txtSchEmpPosition;

      if (!this.OnlyRole) {
        objectjson['RoleCode'] = this.txtSchEmpRole;
      } else {
        objectjson['RoleCode'] = this.OnlyRole;
      }

      if(this.CompanyCode) objectjson['CompanyCode'] = this.CompanyCode;

      if (this.ContactlistProjectCode != null && this.ContactlistProjectCode != '') objectjson['ProjectCode'] = this.ContactlistProjectCode;

      objectjson['EmpType'] = this.checkboxEmpInternal && this.checkboxEmpExternal ? null: !this.checkboxEmpInternal && this.checkboxEmpExternal ? '2' : this.checkboxEmpInternal && !this.checkboxEmpExternal ? '1' : '0' ;
      objectjson['rowFetch'] = this.pagesize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      this.modelOnPromise = this.httpClient
        .post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeModal",
          strjson, httpOptions)
        .toPromise()

      return this.modelOnPromise;
    }
  }

  async LoadJob() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<JobInfo[]>(this.baseurl + "Job/GetJob", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadRole() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<RoleInfo[]>(this.baseurl + "Role/GetRole", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadPosition() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<PositionLevelInfo[]>(this.baseurl + "Position/GetPositionLevelList", strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadDivision() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<DivisionInfo[]>(this.baseurl + "Division/GetDivision", strjson, httpOptions)
        .toPromise()
    }
  }

  //============================ Data Loading [End] =========================================

  //============================ Pagination [Start] =========================================
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadData();
    }
  }

  OnEmpTypeTick(traget = null) {

    console.log(traget)
    console.log("ok")
    console.log(this.checkboxEmpInternal)
    console.log(this.checkboxEmpExternal)
  }
  //============================ Pagination [End] =========================================
}
